module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._c('section', {
    staticClass: "main-content"
  }, [_vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4), _vm._c('div', {
    staticClass: "playground"
  }, [_vm._c('div', {
    staticClass: "form-group"
  }, [_vm._c('p', {
    staticClass: "label"
  }, [_vm._v("placeholder:")]), _vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.placeholder),
      expression: "placeholder"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.placeholder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.placeholder = $event.target.value
      }
    }
  })]), _vm._c('div', {
    staticClass: "form-group"
  }, [_vm._c('p', {
    staticClass: "label"
  }, [_vm._v("readOnly:")]), _vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.readOnly),
      expression: "readOnly"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.readOnly) ? _vm._i(_vm.readOnly, null) > -1 : (_vm.readOnly)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.readOnly,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.readOnly = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.readOnly = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.readOnly = $$c
        }
      }
    }
  })]), _vm._c('div', {
    staticClass: "form-group"
  }, [_vm._c('p', {
    staticClass: "label"
  }, [_vm._v("validate:")]), _vm._c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.validate),
      expression: "validate"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.validate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_vm._c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("No validate")]), _vm._c('option', {
    attrs: {
      "value": "text"
    }
  }, [_vm._v("Text")]), _vm._c('option', {
    attrs: {
      "value": "email"
    }
  }, [_vm._v("Email")]), _vm._c('option', {
    attrs: {
      "value": "url"
    }
  }, [_vm._v("Url")]), _vm._c('option', {
    attrs: {
      "value": "digits"
    }
  }, [_vm._v("Digits")]), _vm._c('option', {
    attrs: {
      "value": "isodate"
    }
  }, [_vm._v("ISO Date")])])]), _vm._c('div', {
    staticClass: "form-group"
  }, [_vm._c('p', {
    staticClass: "label"
  }, [_vm._v("tags:")]), _vm._c('code', [_vm._v(_vm._s(_vm.tags))])]), _vm._c('input-tag', {
    attrs: {
      "on-change": _vm.newTag,
      "tags": _vm.tags,
      "placeholder": _vm.placeholder,
      "read-only": _vm.readOnly,
      "validate": _vm.validate
    }
  }), _vm._c('code', [_vm._v(_vm._s(_vm.getPreviewHTML()))])], 1), _vm._m(5)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('section', {
    staticClass: "page-header"
  }, [_vm._c('h1', {
    staticClass: "project-name"
  }, [_vm._v("Vue.js Input Tag")]), _vm._c('h2', {
    staticClass: "project-tagline"
  }), _vm._c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://github.com/matiastucci/vue-input-tag",
      "target": "_blank"
    }
  }, [_vm._v("GitHub")]), _vm._c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://www.npmjs.com/package/vue-input-tag",
      "target": "_blank"
    }
  }, [_vm._v("NPM")])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('p', [_vm._v("Vue.js 2.0 component, inspired in "), _vm._c('a', {
    attrs: {
      "href": "https://github.com/olahol/react-tagsinput",
      "target": "_blank"
    }
  }, [_vm._v("react-tagsinput ")])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('h3', [_vm._c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "install",
      "href": "#install",
      "aria-hidden": "true"
    }
  }, [_vm._c('span', {
    staticClass: "octicon octicon-link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Install")])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('p', [_vm._c('code', [_vm._v("npm install vue-input-tag --save")])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('h3', [_vm._c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "playground",
      "href": "#playground",
      "aria-hidden": "true"
    }
  }, [_vm._c('span', {
    staticClass: "octicon octicon-link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Playground")])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('footer', {
    staticClass: "site-footer"
  }, [_vm._c('span', {
    staticClass: "site-footer-credits"
  }, [_vm._c('a', {
    attrs: {
      "href": "https://twitter.com/TucciMatias",
      "target": "_blank"
    }
  }, [_vm._v("@TucciMatias")]), _vm._c('span', [_vm._v(" - ")]), _vm._c('a', {
    attrs: {
      "href": "https://tucci.me",
      "target": "_blank"
    }
  }, [_vm._v("tucci.me")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a356e64c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/App.vue
// module id = 49
// module chunks = 0